import { ActionSanitizer } from 'store/devToolsActionSantizer';
import { AnyAction } from 'store/store';
import { countIndexedArray } from 'utils/arrays/arrayUtils';
import { OrdersSetOrdersAction, OrdersActionType } from './actions';
import { OrderStreamUpdatedEvent } from './orderStreamsUpdatedEvent';
import { OrderFilterResultsChangedEvent } from './orderFilterResultsChangedEvent';

export const ordersMessageReceiveBatchSanitizer: ActionSanitizer = <
    A extends AnyAction,
>(
    action: A
) => {
    if (action.type !== OrdersActionType.ORDERS_SET_ORDERS) {
        return action;
    }

    const setAction = action as unknown as OrdersSetOrdersAction;

    return {
        type: OrdersActionType.ORDERS_SET_ORDERS + '_SANITIZED',
        payload: {
            ordersLength: setAction.payload!.orders.length,
            batch: setAction.payload!.batchUpdateInProgress,
        },
    } as unknown as A;
};

export const orderStreamUpdatedEventSanitizer: ActionSanitizer = <
    A extends AnyAction,
>(
    action: A
) => {
    if (action.type !== OrdersActionType.ORDERS_STREAM_UPDATED) {
        return action;
    }

    const payload = action!.payload! as unknown as OrderStreamUpdatedEvent;

    return {
        type: OrdersActionType.ORDERS_STREAM_UPDATED + '_SANITIZED',
        payload: {
            added: countIndexedArray(payload.added),
            updated: countIndexedArray(payload.updated),
            removed: countIndexedArray(payload.removed),
            completesRefresh: payload.completesRefresh,
            batchUpdateInProgress: payload.batchUpdateInProgress,
        },
    } as unknown as A;
};

export const ordersFilterResultsChangedSanitizer: ActionSanitizer = <
    A extends AnyAction,
>(
    action: A
) => {
    if (action.type !== OrdersActionType.ORDERS_FILTER_RESULTS_CHANGED) {
        return action;
    }

    const payload = action!
        .payload! as unknown as OrderFilterResultsChangedEvent;

    return {
        type: OrdersActionType.ORDERS_FILTER_RESULTS_CHANGED + '_SANITIZED',
        payload: {
            changedType: payload.changedType,
            updates: payload.updates && {
                newMembers: countIndexedArray(payload.updates.newMembers),
                removedMembers: countIndexedArray(
                    payload.updates.removedMembers
                ),
                updatedMembers: countIndexedArray(
                    payload.updates.updatedMembers
                ),
            },
        },
    } as unknown as A;
};
